import React, {useCallback, useEffect, useReducer} from 'react';
import {Card, CardActions, CardContent, CardHeader, Container, Paper, Typography} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import Grid from "@mui/material/Grid";
import HideAppBar from "../../../widgets/header/HideAppBar";
import clsx from "clsx";
import PanoramaFishEyeTwoToneIcon from "@mui/icons-material/PanoramaFishEyeTwoTone";
import {amber, indigo} from "@mui/material/colors";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {useHistory, useParams} from "react-router-dom";
import {getAllMonitoraggiBySoggetto, getQuarantenaById} from "../../../../services/QuaranteneServices";
import { Skeleton } from '@mui/material';
import MonitoraggiIsolamentoTable from "./detail/MonitoraggiIsolamentoTable";
import MonitoraggiQuarantenaTable from "./detail/MonitoraggiQuarantenaTable";


const AllMonitoraggi = () => {
	const classes = BaseStyle();
	let history = useHistory();
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	let {id, idSoggetto} = useParams();
	
	const compilaMonitoraggio = useCallback(() => {
		history.push("/gestione/quarantene/" + id + "/soggetto/" + idSoggetto + "/monitoraggio");
	}, [history, id, idSoggetto]);
	
	useEffect(() => {
		getAllMonitoraggiBySoggetto(idSoggetto, quarantenaDispatch)
	}, [idSoggetto, quarantenaDispatch])
	
	useEffect(() => {
		getQuarantenaById(id, quarantenaDispatch);
	}, [id])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	/*
	 Buongiorno,
	 ci scusiamo per il ritardo nella risposta ma le confermo che sono stati creati gli utenti richiesti
	 
	 Con la presente si richiede di abilitare i seguenti utenti al Callcenter: - GARZIERA BETTINA c.f. GRZBTN72T65A479Q email bgarziera@asl.at.it - GARZIERA CELESTINA c.f. GRZCST74H68A479G email cgarziera@asl.at.it Si ringrazia anticipatamente per la collaborazione. Dipartimento di prevenzione ASL AT
	 */
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Monitoraggi del paziente"} back={true}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardHeader
									title={<Typography
										variant={"h6"}><b>Monitoraggi paziente</b></Typography>}
									subheader={
										<Paper variant={"outlined"} className={clsx(classes.roundBorder, classes.padding2)}
										       style={{width: "100%", marginTop: 16}}>
											<Typography variant={"subtitle1"} color={"textSecondary"} style={{marginBottom: 8}}>
												Legenda colori
											</Typography>
											<Grid container spacing={1}>
												<Grid item xs={1}>
													<PanoramaFishEyeTwoToneIcon style={{color: indigo["A700"]}}/>
												</Grid>
												<Grid item xs={2}>
													<Typography>
														SÍ
													</Typography>
												</Grid>
												
												<Grid item xs={1}>
													<PanoramaFishEyeTwoToneIcon/>
												</Grid>
												<Grid item xs={2}>
													<Typography>
														NO
													</Typography>
												</Grid>
												
												<Grid item xs={1}>
													<PanoramaFishEyeTwoToneIcon style={{color: amber[500]}}/>
												</Grid>
												<Grid item xs={5}>
													<Typography>
														NON DICHIARATO
													</Typography>
												</Grid>
											</Grid>
										</Paper>
									}
								/>
								<CardContent style={{flexGrow: 1, overflowX: "auto"}}>
									{
										quarantenaState.loadingGetQuarantena ? <Skeleton/> :
											quarantenaState.errorGetQuarantena !== "" ? "Err..." :
												quarantenaState.quarantena.tipo === "Isolamento" ?
													<MonitoraggiIsolamentoTable monitoraggi={quarantenaState.monitoraggi}/> :
													<MonitoraggiQuarantenaTable monitoraggi={quarantenaState.monitoraggi}/>
									}
								</CardContent>
								<CardActions className={classes.flexRight}>
									<Tooltip
										title={"Invia una mail all'utente per sollecitare la compilazione del monitoraggio. NB: solo se la mail esiste!"}>
										<Button variant={"text"} disableElevation size="small"
										        style={{borderRadius: 24}}
										        className={classes.roundButton}>
											<b>Invia/sollecita monitoraggio</b>
										</Button>
									</Tooltip>
									<Tooltip
										title={"Compila manualmente il monitoraggio del paziente"}>
										<Button variant={"contained"} disableElevation size="small" color="primary"
										        style={{borderRadius: 24}}
										        className={classes.roundButton} onClick={compilaMonitoraggio}>
											<b>Compila monitoraggio</b>
										</Button>
									</Tooltip>
								</CardActions>
							</Card>
						
						</Grid>
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(AllMonitoraggi)
